import { DateTime } from 'luxon';

/**
 * 
 * @param {Json} json 
 * @param {String} locale 
 * @returns {Json}
 */
export default function replace(json, locale = null) {

    if(locale == null) {

        // TODO: What should the env variable be
        locale = process.env.LOCALE || 'sv-SE';
    }

    const dt = DateTime.now().setLocale(locale);
    const currentYear = dt.year;
    const currentMonth = dt.monthLong;

    return JSON.parse(
        JSON.stringify(json)
            .replace(/%year%/g, currentYear)
            .replace(/%month%/g, currentMonth)
    );
}